import { MatDialogRef } from '@angular/material/dialog';

/**
 * Estado de minimizado de un diálogo flotante (sin backdrop), igual que el Asistente IA:
 * minimizado solo queda la cabecera, estrecha, para seguir trabajando en la página de detrás.
 * `flotante` viene de `data.flotante`, así que en las páginas que abren el diálogo como modal no cambia nada.
 */
export class VentanaMinimizable {
  isMinimized = false;

  constructor(
    private readonly dialogRef: MatDialogRef<unknown>,
    public readonly flotante: boolean,
    private anchoNormal: string,
    private readonly anchoMinimizado = '320px'
  ) { }

  toggle(): void {
    this.isMinimized = !this.isMinimized;
    if (this.isMinimized) {
      this.dialogRef.updateSize(this.anchoMinimizado, 'auto');
    } else {
      this.dialogRef.updateSize(this.anchoNormal, '');
    }
  }

  /** Cambia el ancho al que vuelve al restaurar (y lo aplica si no está minimizada). */
  setAnchoNormal(ancho: string): void {
    this.anchoNormal = ancho;
    if (!this.isMinimized) this.dialogRef.updateSize(ancho, '');
  }

  restaurar(): void {
    if (this.isMinimized) this.toggle();
  }
}
